import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import Logger from './Logger';
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

const greenIcon = 'path/to/your/green-icon.png'; // Replace with actual icon path

const MapView = () => {

  // Initialize Logger
  const logger = useRef(new Logger(getLoggerBaseURL())).current;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const lat = parseFloat(params.get('lat'));
  const lng = parseFloat(params.get('lng'));

  const mapContainerStyle = {
    width: '100%',
    height: '100vh',
  };

  const center = {
    lat: lat || 0,
    lng: lng || 0,
  };

  const googleMapRef = useRef(null);

  const addMarker = useCallback((lat, lng, title) => {
    if (!googleMapRef.current) {
      logger.log('Map reference is not available', 'ERROR');
      return;
    }

    new window.google.maps.Marker({
      position: { lat, lng },
      map: googleMapRef.current, // Ensure map is correctly referenced
      title: title,
      icon: {
        url: greenIcon,
        scaledSize: new window.google.maps.Size(40, 40), // Ensure proper size setup
      },
    });
  }, [logger]);

  useEffect(() => {
    if (googleMapRef.current && lat && lng) {
      addMarker(lat, lng, 'Driver Location');
    }
  }, [lat, lng, addMarker]);

  const onMapLoad = (map) => {
    googleMapRef.current = map; // Store the map instance
  };

  return (
    <div>
      <LoadScript googleMapsApiKey="AIzaSyASvHxca4NGb5ObLmhETGUOmfWDMpcdmUg">
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={15}
          onLoad={onMapLoad} // Assign onLoad handler
        />
      </LoadScript>
    </div>
  );
};

export default MapView;
